import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from 'techlify-ng';
import { AlertService } from 'techlify-ng';
import { RequestErrorService } from 'techlify-ng';

import { User } from './user.model'
import { Role } from './role.model';

/**
 * Component to edit a user
 * 
 * @author Joshua Kissoon
 * @since 20170710
 */
@Component({
    selector: 'user-edit',
    templateUrl: './user-form.html'
})
export class UserEdit implements OnInit {
    @Input() user: User;
    @Output() onSave: EventEmitter<User>;

    public isWorking = false;

    public roles: Role[];
    public rolesModel: any;

    constructor(private dataManager: DataManager, private alertService: AlertService,
        private errorHandler: RequestErrorService) {
        this.onSave = new EventEmitter<User>();

        this.roles = new Array<Role>();
        this.rolesModel = {};
    }

    ngOnInit() {
        console.log(this.user);
        this.loadRoles();
    }

    loadRoles() {
        this.isWorking = true;
        this.dataManager.GET("api/roles", { "client_id": this.user.client_id }).then(
            res => {
                this.roles = res.data;

                /* Lets set the roles this user has */
                for (var role of this.roles) {
                    this.rolesModel[role.id] = this.user.hasRole(role.id);
                }
                this.isWorking = false;
            }
        );
    }

    saveUser() {
        this.isWorking = true;

        var data = JSON.parse(JSON.stringify(this.user));
        data.roles = {};

        for (var i in this.rolesModel) {
            data.roles[i] = this.rolesModel[i];
        }

        this.dataManager.PUT("api/users/" + this.user.id, data).then(
            res => {
                if (!res.item) {
                    this.alertService.addAlert("Failed to update the user. ", "warning");
                    return;
                }

                this.onSave.emit(res.item);
                this.alertService.addAlert("Successfully updated the user. ", "success");
                this.isWorking = false;
            },
            error => {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }

}